import Navbar from './components/Navbar';
import Hero from './components/Hero';

const HomePage = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <Hero />
      </main>
    </div>
  );
};

export default HomePage;
